import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import TopMenu from "../top-menu";
import StatusBar from "../masthead/status-bar";
import Avatar from "../masthead/avatar";
import MainContent from "../main-content";
import FooterActionsView from "../generic/footer-actions";
import GlobalBehaviors from "../../behaviors/global";
import ChartReviewBehaviors from "../../behaviors/chart-reviews";
import MembersBehaviors from "../../behaviors/members";
import ProviderGroupsBehaviors from "../../behaviors/provider-groups";
import HamburgerBehaviors from "../../behaviors/hamburger";

const channel = Radio.channel("global");

const DEFAULTS = {
  el: "#app",
  template: false,
  regions: {
    statusBar: "#header .nav-group.status",
    topMenu: "#header .nav-group.right",
    avatar: "#avatar",
    sideMenu: "#side-menu",
    footerActions: "footer .actions",
  },
};

class Layout extends Marionette.LayoutView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  behaviors() {
    return [
      { behaviorClass: GlobalBehaviors },
      { behaviorClass: ChartReviewBehaviors },
      { behaviorClass: MembersBehaviors },
      { behaviorClass: ProviderGroupsBehaviors },
      { behaviorClass: HamburgerBehaviors },
    ];
  }

  initialize() {
    // soften view swapping
    this.regionManager.each((region) => {
      region.onBeforeShow = () => {
        region.$el.hide();
      };
      region.onShow = () => {
        region.$el.fadeIn("slow");
      };
    });
  }

  onBeforeRender() {
    // attach main section layout
    new MainContent();
  }

  onBeforeShow() {
    // load views
    this.statusBar.show(new StatusBar());

    this.avatar.show(new Avatar());

    this.topMenu.show(new TopMenu());

    this.footerActions.show(new FooterActionsView());
  }

  onAttach() {
    channel.trigger("layout-ready", this);
  }
}

export { Layout as default };
